<script>
    export let message = 'Loading';
    export let status;
    export let error;
    if (error) {
        if (!error.list) error.list = [];
        if (!Array.isArray(error.list)) error.list = [error.list];
        error.list = error.list.map(item=>{
            if (typeof(item)==='string') {
                return {message:item}
            }
            return item;
        });
    }
</script>

<div class:hidden={error || status} >
    <div style="height:10em;display: flex;flex-direction: column;justify-content: center;align-items: center;text-align:center">
        <img src="/blt/client/images/loading.gif" alt="loading" />
        <div style='margin-top:.5em'>
            <strong style='font-size:1.15em;color:#4C75A3'>{message}</strong>
        </div>
    </div>
</div>

{#if status}
<div >
    <h4 style="margin:.5em 0em;color:#0066CC">{status.head  || 'BLT status:' }</h4>
    {status.message}
</div>
{/if}

{#if error}
<div style="color:red">
    <h4 >{error.head  || 'BLT produced the following errors:' }</h4>
    <ul>
    {#each error.list || [] as item}
        <li>{item.message}
            {#if error.showStack!==false && item.stack}
                :<br/>{item.stack}
            {/if}
        </li>
    {/each}
    </ul>
</div>
{/if}
